const getProp = require("dotprop");

let CommonPlugin = Object();

CommonPlugin.install = function(Vue) {
  Vue.mixin({
    methods: {
      $getIcon(name) {
        return getProp(this.$options, ["icons", name]);
      },
      logout() {
        this.$auth.logout();
        this.$store.dispatch("shell/showSnackbar", {
          text: `Successfully logged out.`
        });
        this.$router.push(`/login`);
      },
      $getProp(o, p) {
        return getProp(o, p);
      }
    }
  });
};

export default CommonPlugin;
